<template lang="pug">
  v-card.pa-4.mx-auto(
    max-width="1200"
  )

    v-toolbar-title Настройки

    v-row(align="center").mt-3

      v-col.d-flex.align-center(cols="12" sm="6" lg="4")
        v-select.mr-auto(
          :items="languages"
          :value="locale"
          label="Перевод"
          flat
          hide-details
          outlined
          dense
          background-color="white"
          @change="onChangeLanguage"
        )

</template>

<script>

/**
 * @displayName Post settings
 */
export default {
  props: {
    locale: {
      type: String,
      default: 'ru',
    },
    languages: {
      type: Array,
      default: () => [
        {
          text: 'Russian',
          value: 'ru',
        },
      ],
    },
  },
  methods: {
    onChangeLanguage(val) {
      /**
       * Triggers when language changes
       *
       * @property {string|object} val
       */
      this.$emit('languageChanged', val)
    },
  },
}
</script>
